/**
 * Tono por tipo de owner de un equipo entregado (card de métricas y etiqueta de
 * la fila). Archivo aparte del componente por react-refresh/only-export-components.
 */
import type { DeliveredOwnerKind } from '@/../../shared/types';

export const DELIVERED_KIND_CLASSES: Record<DeliveredOwnerKind, string> = {
  clapper: 'text-emerald-700 dark:text-emerald-300',
  former: 'text-red-700 dark:text-red-300',
  not_in_map: 'text-amber-700 dark:text-amber-300',
  external: 'text-slate-600 dark:text-slate-300',
  no_owner: 'text-slate-500 dark:text-slate-400',
};
